module.exports = require("./qu-PE.js");